import React from 'react';
import { useTranslation } from 'react-i18next';

function ReconnectOverlay({ mode, secondsLeft, name }) {
    const { t } = useTranslation();

    if (mode === 'self') {
        return (
            <div className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center p-4">
                <div className="neon-panel scanlines p-6 sm:p-10 max-w-md w-full text-center border-cyber-cyan shadow-neon">
                    <div className="w-3 h-3 rounded-full bg-cyber-cyan animate-pulse shadow-neon mx-auto mb-4" />
                    <div className="font-display text-cyber-cyan glow-cyan tracking-widest text-lg sm:text-2xl mb-3">
                        {t('game.reconnecting')}
                    </div>
                    <div className="font-display text-cyber-pink glow-pink text-3xl sm:text-4xl font-black animate-pulse">
                        {t('game.reconnectSecondsLeft', { seconds: secondsLeft })}
                    </div>
                    <div className="text-cyber-dim tracking-widest text-[10px] mt-4">
                        {t('game.reconnectHint')}
                    </div>
                </div>
            </div>
        );
    }

    if (mode === 'opponent') {
        return (
            <div className="fixed top-4 left-1/2 -translate-x-1/2 z-40 neon-panel px-4 py-2 border-cyber-pink shadow-neon max-w-[92vw]">
                <div className="flex items-center gap-2 sm:gap-3">
                    <div className="w-2 h-2 rounded-full bg-cyber-pink animate-pulse shadow-neon" />
                    <div className="font-display text-cyber-pink glow-pink tracking-widest text-[10px] sm:text-xs">
                        {name ? `${name} — ` : ''}{t('game.opponentDisconnected')}
                    </div>
                    <span className="text-cyber-dim text-[10px] sm:text-xs tracking-widest">·</span>
                    <div className="font-display text-cyber-cyan glow-cyan tracking-widest text-[10px] sm:text-xs">
                        {t('game.forfeitIn', { seconds: secondsLeft })}
                    </div>
                </div>
            </div>
        );
    }

    return null;
}

export default ReconnectOverlay;
